var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckWhiteIcon = function SvgCheckWhiteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0545 0.647504C12.8037 0.410308 12.4081 0.421312 12.1709 0.672082L4.56546 8.71281L2.07551 5.5315L2.01325 5.46294C1.79234 5.25312 1.44524 5.23113 1.19813 5.42454C0.926306 5.63728 0.878419 6.0301 1.09117 6.30192L4.00783 10.0284L4.05252 10.0776C4.05767 10.0835 4.06295 10.0893 4.06835 10.0951L4.07009 10.097L4.07086 10.0977C4.07833 10.1056 4.08605 10.1132 4.09401 10.1208C4.34478 10.358 4.74035 10.347 4.97755 10.0962L13.0791 1.53105L13.1376 1.45929C13.3123 1.20966 13.2825 0.863137 13.0545 0.647504Z",
    fill: "white"
  })));
};
export default SvgCheckWhiteIcon;